
import { Organization } from '../../organization/organization.model';
import {MonetaryArea} from '../monetary-areas/monetary-area.model';

export class Country {
  reference: string;
  name: string;
  countryCode: string;
  countryPhoneCode: string;
  monetaryArea: any;
  refundOrganization?: any;


  constructor(reference: string = null,
              name: string = null,
              countryCode: string = null,
              countryPhoneCode: string  = null,
              monetaryArea: any = new MonetaryArea()) {
    this.reference = reference;
    this.name = name;
    this.countryCode = countryCode;
    this.countryPhoneCode = countryPhoneCode;
    this.monetaryArea = monetaryArea;
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/parameters/countries/country.model.ts